const hideHeaderSection = (counts) => {
  const resultsContainer = document.querySelector('[data-search-results-content]');
  const isNoResults = counts === 0;
  const hiddenSections = document.querySelectorAll('[data-hidden-section]');

  if (!isNoResults) {
    hiddenSections.forEach(element => element.removeAttribute('hidden'));
    resultsContainer.classList.remove('nhs-c-wrapper--no-results', 'nhs-mq-wrapper--no-results-medium');
    return;
  }

  hiddenSections.forEach(element => element.setAttribute('hidden', ''));
  resultsContainer.classList.add('nhs-c-wrapper--no-results', 'nhs-mq-wrapper--no-results-medium');
};

export default hideHeaderSection;